/**
 * @generated SignedSource<<a554de02ad088adb19aa91e13e3d4eec>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilterBooleanOperator = "AND" | "NOT" | "OR" | "%future added value";
export type FilterElementInput = {
  multiple?: FilterBooleanOperationInput | null | undefined;
  single?: FilterValueInput | null | undefined;
};
export type FilterValueInput = {
  name: string;
  operator?: string | null | undefined;
  value?: string | null | undefined;
  values?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type FilterBooleanOperationInput = {
  operands: ReadonlyArray<FilterElementInput>;
  operator: FilterBooleanOperator;
};
export type JiraAssigneeAccountTagKeysPaginationQuery$variables = {
  count?: number | null | undefined;
  cursor?: string | null | undefined;
  filter?: FilterElementInput | null | undefined;
};
export type JiraAssigneeAccountTagKeysPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"JiraAssignee_accountTagKeys">;
};
export type JiraAssigneeAccountTagKeysPaginationQuery = {
  response: JiraAssigneeAccountTagKeysPaginationQuery$data;
  variables: JiraAssigneeAccountTagKeysPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 100,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "filterElement",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "JiraAssigneeAccountTagKeysPaginationQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
          }
        ],
        "kind": "FragmentSpread",
        "name": "JiraAssignee_accountTagKeys"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "JiraAssigneeAccountTagKeysPaginationQuery",
    "selections": [
      {
        "alias": "jiraAssigneeAccountTagKeys",
        "args": (v1/*:: as any*/),
        "concreteType": "AccountTagKeyConnection",
        "kind": "LinkedField",
        "name": "accountTagKeys",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountTagKeyEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountTagKey",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "jiraAssigneeAccountTagKeys",
        "args": (v1/*:: as any*/),
        "filters": [
          "filterElement"
        ],
        "handle": "connection",
        "key": "JiraAssignee__jiraAssigneeAccountTagKeys",
        "kind": "LinkedHandle",
        "name": "accountTagKeys"
      }
    ]
  },
  "params": {
    "cacheID": "850173e38118d245e8c2c96e4d574c6a",
    "id": null,
    "metadata": {},
    "name": "JiraAssigneeAccountTagKeysPaginationQuery",
    "operationKind": "query",
    "text": "query JiraAssigneeAccountTagKeysPaginationQuery(\n  $count: Int = 100\n  $cursor: String\n  $filter: FilterElementInput\n) {\n  ...JiraAssignee_accountTagKeys_3KQYpM\n}\n\nfragment JiraAssignee_accountTagKeys_3KQYpM on Query {\n  jiraAssigneeAccountTagKeys: accountTagKeys(first: $count, after: $cursor, filterElement: $filter) {\n    edges {\n      node {\n        key\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e7b3f5ddfdc99efaf8befabcb061542a";

export default node;
